/* eslint-disable max-len, max-statements, no-unused-vars, no-console */
/* eslint-disable react/jsx-max-depth, react/no-unescaped-entities */
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { Container } from "react-bootstrap";

import AssessmentData from "../../liaStatements/statements_en.json";
import Instructions from "./Instructions";
import ProfileCompleteDashboard from "./ProfileCompleteDashboard";
import { getProfileProgress } from "../../helpers/respondents";
import { useQueryClient } from "react-query";
import { useUser } from "../UserContext";

const Dashboard = () => {
	const { user, respondent } = useUser();
	const navigate = useNavigate();

	const queryClient = useQueryClient();
	useEffect(() => {
		/*
		 * Always refresh respondent when we load the user
		 * this prevents stale data preventing proper resuming of progress
		 * in the assessment as the user navigates around the app
		 */
		queryClient.invalidateQueries(["respondent", user?.respondentId]);
	
		if (! user?.weqProfileId) {
			navigate("/sign-up/questionnaire");
		}
	
	}, [user]);

	const progress = useMemo(() => ({ ...getProfileProgress(respondent?.weqProfile?.profileResponses || [], AssessmentData.scenarios) }), [respondent]);
	const profileCompleted = useMemo(() => respondent?.profilecomplete || respondent?.weqProfile?.profilestatus === "completed" || respondent?.weqProfile?.profilestatus === "review", [respondent]);

	return (
		<Container className="bg-white rounded-3" style={{ marginTop: "40px" }}>
			{ respondent && !profileCompleted ?
				<Instructions readInstructions={respondent?.weqProfile?.readInstructions} /> : null }
			{ respondent?.weqProfile?.readInstructions && !profileCompleted ? (
				<NavLink className="btn btn-gradient w-100 mt-4 w-100" to={`/profile/assessment/${progress.nextScenario || 1}`}>
					Continue Assessment <ArrowRightIcon height={24} width={24} />
				</NavLink>
			) : null }
			{ profileCompleted ? <ProfileCompleteDashboard /> : null }
		</Container>
	);
};

export default Dashboard;
